module.exports = __webpack_public_path__ + "static/media/day08_cardflip.a86454f6.gif";